import React from 'react';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
  Box,
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  Divider,
  useMediaQuery,
  useTheme
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Header from './components/Header';
import Footer from './components/Footer';
import { useTranslation } from 'react-i18next';
import { BRAND, BRAND_GRADIENTS } from '../../config/brand';
import PublicAiChatWidget from './components/PublicAiChatWidget';

// Stil tanımlamaları
const PageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  background: BRAND_GRADIENTS.vertical, // BRAND'den
  overflow: 'hidden', // Ana sayfanın kaydırmasını engelle
}));

const ContentSection = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto', // Sadece bu alanda kaydırma çubuğu olsun
  padding: theme.spacing(8, 2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(6, 1),
  },
}));


const ContactCard = styled(Card)(({ theme }) => ({
  height: '100%',
  borderRadius: 16,
  boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-10px)',
  },
  display: 'flex',
  flexDirection: 'column',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
  '& svg': {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
}));

const CityTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
  textAlign: 'center',
  fontSize: '1.5rem',
}));


const Contact: React.FC = () => {
  const { t } = useTranslation();

  // Ofis bilgileri BRAND'den alınıyor (build'e göre değişir)
  const contactOffices = BRAND.offices.map(office => ({
    ...office,
    email: BRAND.contact.email, // Ortak email
  }));

  return (
    <PageContainer>
      <Header />

      <ContentSection>
        <Container maxWidth="lg">
          <Typography 
            variant="h2" 
            sx={{ 
              color: 'white', 
              fontWeight: 700, 
              textAlign: 'center', 
              mb: 6,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
            }}
          >
            {t('contact.title')}
          </Typography>
          
          <Grid container spacing={4}>
            {contactOffices.map((office, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <ContactCard>
                  <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <CityTitle variant="h5">
                      {office.city}
                    </CityTitle>
                    
                    <Divider sx={{ mb: 2 }} />
                    
                    <IconWrapper>
                      <LocationOnIcon />
                      <Typography variant="body2">
                        {office.address}
                      </Typography>
                    </IconWrapper>
                    
                    <IconWrapper>
                      <EmailIcon />
                      <Typography variant="body2">
                        {office.email}
                      </Typography>
                    </IconWrapper>
                    
                    <IconWrapper>
                      <PhoneIcon />
                      <Typography variant="body2">
                        {office.phone}
                      </Typography>
                    </IconWrapper>
                  </CardContent>
                </ContactCard>
              </Grid>
            ))}
          </Grid>
          
          <Box sx={{ mt: 8, textAlign: 'center' }}>
            <Typography variant="h4" sx={{ color: 'white', mb: 2 }}>
              {t('contact.customerService')}
            </Typography>
            <Typography variant="h6" sx={{ color: 'white', opacity: 0.9 }}>
              {BRAND.contact.customerService}
            </Typography>
          </Box>
        </Container>
        <Footer />
      </ContentSection>

      <PublicAiChatWidget />
    </PageContainer>
  );
};

export default Contact; 